import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import "./style.scss"
import { IDefaultError } from "./types"

export const DefaultError: FC<IDefaultError> = ({ error }) => {
  const { t } = useTranslation()

  return (
    <Container
      className="default-error fullscreen"
      triangleTopPosLeft={"20px"}
      triangleBottomPosLeft={"90%"}
    >
      <h1>{t("error.oops")}</h1>
      <h2>{t("error.itSeems")}</h2>
      <Container className="error-info">
        {error.name && (
          <>
            <p>
              <span>Name:</span> {error.name}
            </p>
            <hr />
          </>
        )}
        {error.message && (
          <>
            <p>
              <span>Message:</span> {error.message}
            </p>
            <hr />
          </>
        )}
        {error.stack && (
          <p>
            <span>Details:</span> {error.stack}
          </p>
        )}
      </Container>
      <h3>{t("error.pleaseCopy")}</h3>
      <Button
        onClick={() => {
          const payload = JSON.stringify({
            name: error.name,
            message: error.message,
            stack: error.stack
          })
          void navigator.clipboard?.writeText(payload).catch(() => {})
        }}
      >
        {t("error.copy")}
      </Button>
    </Container>
  )
}
